import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative my-auto h-2 flex-1 overflow-hidden rounded-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gradient-3 opacity-10" }, null, -1)
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm font-semibold"
}
const _hoisted_5 = {
  key: 1,
  class: "text-xs text-subtle"
}
const _hoisted_6 = {
  key: 2,
  class: "text-xs text-subtle"
}

import { computed } from 'vue';
import checklistStrings from './checklist-strings';

type Props = {
  section?: string;
  steps: {
    total: number;
    completed: number;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsProgress',
  props: {
    section: null,
    steps: null
  },
  setup(__props: any) {

const props = __props as {
  section?: string;
  steps: {
    total: number;
    completed: number;
  };
};



const progress = computed(() => Math.round(((props.steps.completed / props.steps.total) * 100)));

const containerClass = computed(() => ['flex flex-row gap-2 py-1', props.section ? 'gap-3' : 'items-end'].join(' '));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(containerClass))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "absolute inset-0 rounded-full bg-gradient-2 opacity-100 transition-all",
        style: _normalizeStyle({ width: `${_unref(progress)}%` })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (__props.section)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(checklistStrings).sections[__props.section]), 1))
        : _createCommentVNode("", true),
      (__props.section)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.steps.completed) + " / " + _toDisplayString(props.steps.total) + " tasks complete ", 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(progress)) + "% complete ", 1))
    ])
  ], 2))
}
}

})